<template>
  <div>
    <loading-container v-if="loading"></loading-container>

    <div v-else class="container">
      <div class="row" style="margin-bottom: 22px;">
        <div v-if="hasPermission('admin')" class="col-xs-4 col-sm-offset-12">
          <select-widget
              v-model="targetMetric"
              :options="[{value: 'time_channel_target', label: 'Target'}, {value: 'time_channel_management_target', label: 'Management Target'}]"
          ></select-widget>
        </div>

        <div class="col-xs-4" :class="hasPermission('admin') ? '' : 'col-sm-offset-16'">
          <TypeaheadWidget
              v-model="user"
              name="user_id"
              endpoint="/api/v2/users"
              :token="shared.token"
              path="data.data"
              placeholder="(all users)"
              :result-label-property="row => row.attributes.full_name"
          />
        </div>

        <div class="col-xs-4">
          <div class="dashboard-date-widget">
            <date-widget :value="year" format="YYYY" original-format="YYYY" @input="navigate"></date-widget>

            <i class="dashboard-date-widget__icon fa fa-sort"></i>
          </div>
        </div>
      </div>

      <hr class="panel-separator">

      <div class="row">
        <div class="col-sm-8">
          <index-number
              :year="year"
              :time-based-subchannel="timeBasedSubchannel"
              :target-metric="targetMetric"
              :user="user"
          ></index-number>
        </div>

        <div class="col-sm-8">
          <revenue-number
              :year="year"
              :time-based-subchannel="timeBasedSubchannel"
              :target-metric="targetMetric"
              :user="user"
          ></revenue-number>
        </div>

        <div class="col-sm-8">
          <difference-number
              :year="year"
              :time-based-subchannel="timeBasedSubchannel"
              :target-metric="targetMetric"
              :user="user"
          ></difference-number>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <monthly-overview
              :year="year"
              :time-based-subchannel="timeBasedSubchannel"
              :filters="filters"
              :target-metric="targetMetric"
              :user="user"
              :portal="portal"
          ></monthly-overview>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.dashboard-date-widget {
  position: relative;
}

.dashboard-date-widget__icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
</style>

<script>
import http from '@/http'
import store from '@/store'
import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'
import DifferenceNumber
  from '@/pages/Administration/Portals/Edit/Tabs/TimeBasedSubchannelDashboard/Panels/DifferenceNumber'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import IndexNumber from '@/pages/Administration/Portals/Edit/Tabs/TimeBasedSubchannelDashboard/Panels/IndexNumber'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import MonthlyOverview
  from '@/pages/Administration/Portals/Edit/Tabs/TimeBasedSubchannelDashboard/Panels/MonthlyOverview'
import Permissions from '@/mixins/Permissions'
import RevenueNumber
  from '@/pages/Administration/Portals/Edit/Tabs/TimeBasedSubchannelDashboard/Panels/RevenueNumber'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TypeaheadWidget from "../../../../../../vendor/forms/FormGroups/Widgets/Typeahead.vue";

export default {
  components: {
    TypeaheadWidget,
    DateWidget,
    DifferenceNumber,
    HeadlineContainer,
    IndexNumber,
    LoadingContainer,
    MonthlyOverview,
    RevenueNumber,
    SelectWidget
  },

  mixins: [Permissions],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal','year', 'timeBasedSubchannelId'],

  data() {
    return {
      targetMetric: 'time_channel_target',
      user: null,
      timeBasedSubchannel: null,
      loading: true,
      shared :store
    }
  },

  mounted() {
    http.get('/api/v2/time-based-subchannels/' + this.timeBasedSubchannelId).then(response => {
      this.timeBasedSubchannel = response.data.data

      this.loading = false
    })
  },

  computed: {
    filters() {
      return [
        {dimension: 'time_based_subchannel_id', value: this.timeBasedSubchannelId},
      ]
    }
  },

  methods: {
    navigate(year) {
      this.$router.push(year)
    }
  }
}
</script>
